import React from "react";
import CustomChip from "../Chip";
import { vehicle, verificationbadge } from "../../common/svg";
import PhotoGrid from "../ImageView";
import { TimelinePoint } from "../../service/interfaces/Components";
import SecureImage from "../../components/BucketImage/Image";
import { localImages } from "../../common/localImages";
import { edit } from "../../common/svg";
import { PickupModal } from "../Pickup/PickupModal";
import { OperationType } from "../../service/interfaces/Pickup.interface";
// SVG Truck icon component
const TruckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    stroke="currentColor"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 3h15v13H1z" />
    <path d="M16 8h4l3 3v5h-7V8z" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);



type DeliveryTimelineProps = {
  tripId?: string | number;
};

const DeliveryTimeline: React.FC<DeliveryTimelineProps> = ({ tripId }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [operationType, setOperationType] = React.useState<OperationType>("pickup");

  const openFor = (type: OperationType) => {
    setOperationType(type);
    setIsModalOpen(true);
  };
  const timelineData: TimelinePoint[] = [
    {
      title: "Pickup Point",
      distance: "(0 Kms)",
      isActive: true,
      isCompleted: true,
      vehicleInfo: {
        number: "TN 73A 6030",
        temperature: "20°",
        odometer: "ODO 673736 KM",
      },
      events: [
        {
          title: "Pickup Truck arrived at Pickup Point",
          timestamp: "09:10 PM",
          date: "Fri 25-oct-2024",
          description: "",
          images: [
            localImages.americanStyleTruck,
            localImages.semiTruckFact,
            localImages.semiTruckFact,
          ],
        },
        {
          title: "Containers Loaded on the Pickup Truck",
          timestamp: "09:10 PM",
          date: "Fri 25-oct-2024",
          description: "",
          images: [
            localImages.americanStyleTruck,
            localImages.semiTruckFact,
            localImages.semiTruckFact,
          ],
        },
        {
          title: "Pickup Truck left Pickup Point",
          timestamp: "09:10 PM",
          date: "Fri 25-oct-2024",
          description: "",
          images: [
            localImages.americanStyleTruck,
            localImages.semiTruckFact,
            localImages.semiTruckFact,
          ],
        },
      ],
    },
    {
      title: "Loading Point",
      distance: "(150 Kms)",
      isActive: true,
      isCompleted: false,
      events: [],
    },
    {
      title: "Clearance Point",
      distance: "(370 Kms)",
      isActive: false,
      events: [],
    },
    {
      title: "Unloading Point",
      distance: "(397 Kms)",
      isActive: false,
      events: [],
    },
  ];

  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="relative">
        {timelineData.map((point, index) => (
          <div key={index} className="relative">
            {/* Vertical line */}
            {index < timelineData.length - 1 && (
              <div
                className={`absolute left-[9px] top-6 w-[2px] h-[calc(100%)] ${point.isCompleted
                  ? "bg-[#04D900]"
                  : "border-l-2 border-dashed border-[#444FBD]"
                  }`}
              ></div>
            )}

            <div className="flex mb-8">
              {/* Timeline point */}
              <div className="relative">
                <div
                  className={`w-[20px] h-[20px] rounded-full z-10 relative ${point.isCompleted
                    ? "bg-[#04D900] border-[#04D900]"
                    : "bg-white border-[#444FBD]"
                    } border-2`}
                ></div>
              </div>

              {/* Content */}
              <div className="ml-6 flex-1">
                {/* Point header */}
                <div className="flex items-center mb-2">
                  <p className="text-[16px] font-medium">
                    {point.title}{" "}
                    <span className="text-gray-500 text-[14px]">
                      {point.distance}
                    </span>
                  </p>
                  {/* Hover edit icon */}
                  <button
                    className="opacity-100 transition ml-2 border rounded-full p-1 cursor-pointer hover:bg-gray-100"
                    title="Edit"
                    onClick={() => {
                      const title = (point.title || '').toLowerCase();
                      let type: OperationType = "pickup";
                      if (title.includes("loading")) type = "loading";
                      else if (title.includes("clearance")) type = "clearance";
                      else if (title.includes("unloading")) type = "unloading";
                      else type = "pickup";
                      openFor(type);
                    }}
                  >
                    <SecureImage fileKey={edit} alt="edit" width="16px" />
                  </button>
                  {point.isCompleted && (
                    <div className="flex ml-2 gap-2">
                      <SecureImage

                        fileKey={verificationbadge}
                        alt="header icon"
                        width=""
                      />
                      <CustomChip
                        text="Completed"
                        textColor="#04D900"
                        borderColor="#04D900"
                        backgroundColor="#ECFFEB"
                      />
                    </div>
                  )}
                </div>

                {/* Vehicle info */}
                {point.vehicleInfo && (
                  <div className="flex items-center w-fit gap-2 mb-4 justify-around border-[0.5px] border-[#B9BBBC] relative -left-4 px-3 rounded-[15px] text-[14px] text-gray-500">
                    <div className="flex items-center">
                      <span className="mr-1">
                        <SecureImage

                          fileKey={vehicle}
                          alt="header icon"
                          width="40px"
                        />
                      </span>
                      {point.vehicleInfo.number}
                    </div>
                    <div>{point.vehicleInfo.temperature}</div>
                    <div>{point.vehicleInfo.odometer}</div>
                  </div>
                )}

                {/* Events */}
                {point.events?.map((event, eventIndex) => (
                  <div
                    key={eventIndex}
                    className={`mb-${eventIndex === point.events!.length - 1 ? 0 : "4"
                      }`}
                  >
                    <div className="flex items-center gap-2 mb-1">
                      <div className="">
                        <span className="font-[600] text-[16px]">{event.timestamp}</span>
                      </div>
                      <div className="border-l-2 px-4 border-[#444FBD]">
                        <p className="text-[14px]">{event.title}</p>
                        <span className="text-gray-500 text-[14px]">
                          {event.date}
                        </span>
                        {
                          event.images && event.images.length > 0 &&
                          <PhotoGrid images={event.images} />
                        }
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Operation modal */}
      <PickupModal
        isOpen={isModalOpen}
        tripId={String(tripId ?? '')}
        operationType={operationType}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default DeliveryTimeline;
